'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Badge = require('./Badge');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Badge).default;
  }
});

var _NotificationBadge = require('./NotificationBadge');

Object.defineProperty(exports, 'NotificationBadge', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NotificationBadge).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }